module.exports = __webpack_public_path__ + "media/images/partner-3-d28410293c6f920ada1acfef69aae877.png";